export const buildGatewayAuth = ({
    type,
    formValues,
    savedgateway,
}: any) => {

let newVALUE;
if (type === "Pix") {
newVALUE = {
    name_live:
    formValues?.is_live === true
        ? formValues?.name_live
        ? formValues?.name_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.name_live
        ? savedgateway[0]?.inputs?.name_live
        : "",
    name_test:
    formValues?.is_live === false
        ? formValues?.name_test
        ? formValues?.name_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.name_test
        ? savedgateway[0]?.inputs?.name_test
        : "",

    email_live:
    formValues?.is_live === true
        ? formValues?.email_live
        ? formValues?.email_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.email_live
        ? savedgateway[0]?.inputs?.email_live
        : "",
    // business_name: formValues?.business_name
    //   ? formValues?.business_name?.trim()
    //   : "",
    email_test:
    formValues?.is_live === false
        ? formValues?.email_test
        ? formValues?.email_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.email_test
        ? savedgateway[0]?.inputs?.email_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
    priority: formValues?.priority,
};
}
if (type === "Stripe") {
newVALUE = {
    statement_descriptor: formValues?.statement_descriptor
    ? formValues?.statement_descriptor
    : "",
    statement_descriptor_suffix: formValues?.statement_descriptor_suffix
    ? formValues?.statement_descriptor_suffix
    : "",
    secret_key_live:
    formValues?.is_live === true
        ? formValues?.secret_key_live
        ? formValues?.secret_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.secret_key_live
        ? savedgateway[0]?.inputs?.secret_key_live
        : "",
    secret_key_test:
    formValues?.is_live === false
        ? formValues?.secret_key_test
        ? formValues?.secret_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.secret_key_test?.trim()
        ? savedgateway[0]?.inputs?.secret_key_test
        : "",
    priority: formValues?.priority,
    mark_up: formValues?.mark_up,
};
}
if (type === "Raypd") {
newVALUE = {
    secret_key_live:
    formValues?.is_live === true
        ? formValues?.secret_key_live
        ? formValues?.secret_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.secret_key_live
        ? savedgateway[0]?.inputs?.secret_key_live
        : "",
    secret_key_test:
    formValues?.is_live === false
        ? formValues?.secret_key_test
        ? formValues?.secret_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.secret_key_test
        ? savedgateway[0]?.inputs?.secret_key_test
        : "",
    mid_country_live:
    formValues?.is_live === true
        ? formValues?.mid_country_live
        ? formValues?.mid_country_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.mid_country_live
        ? savedgateway[0]?.inputs?.mid_country_live
        : "",
    mid_country_test:
    formValues?.is_live === false
        ? formValues?.mid_country_test
        ? formValues?.mid_country_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.mid_country_test
        ? savedgateway[0]?.inputs?.mid_country_test
        : "",
    access_key_live:
    formValues?.is_live === true
        ? formValues?.access_key_live
        ? formValues?.access_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.access_key_live
        ? savedgateway[0]?.inputs?.access_key_live
        : "",
    access_key_test:
    formValues?.is_live === false
        ? formValues?.access_key_test
        ? formValues?.access_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.access_key_test
        ? savedgateway[0]?.inputs?.access_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Banwire") {
newVALUE = {
    username_live:
    formValues?.is_live === true
        ? formValues?.username_live
        ? formValues?.username_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.username_live
        ? savedgateway[0]?.inputs?.username_live
        : "",
    username_test:
    formValues?.is_live === false
        ? formValues?.username_test
        ? formValues?.username_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.username_test
        ? savedgateway[0]?.inputs?.username_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Valitor") {
newVALUE = {
    apikey_live:
    formValues?.is_live === true
        ? formValues?.apikey_live
        ? formValues?.apikey_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.apikey_live
        ? savedgateway[0]?.inputs?.apikey_live
        : "",
    apikey_test:
    formValues?.is_live === false
        ? formValues?.apikey_test
        ? formValues?.apikey_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.apikey_test
        ? savedgateway[0]?.inputs?.apikey_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Bambora") {
newVALUE = {
    merchantId_live:
    formValues?.is_live === true
        ? formValues?.merchantId_live
        ? formValues?.merchantId_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchantId_live
        ? savedgateway[0]?.inputs?.merchantId_live
        : "",
    merchantId_test:
    formValues?.is_live === false
        ? formValues?.merchantId_test
        ? formValues?.merchantId_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchantId_test
        ? savedgateway[0]?.inputs?.merchantId_test
        : "",
    passcode_live:
    formValues?.is_live === true
        ? formValues?.passcode_live
        ? formValues?.passcode_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.passcode_live
        ? savedgateway[0]?.inputs?.passcode_live
        : "",
    passcode_test:
    formValues?.is_live === false
        ? formValues?.passcode_test
        ? formValues?.passcode_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.passcode_test
        ? savedgateway[0]?.inputs?.passcode_test
        : "",
    hash_key_test:
    formValues?.is_live === false
        ? formValues?.hash_key_test
        ? formValues?.hash_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.hash_key_test
        ? savedgateway[0]?.inputs?.hash_key_test
        : "",
    hash_key_live:
    formValues?.is_live === true
        ? formValues?.hash_key_live
        ? formValues?.hash_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.hash_key_live
        ? savedgateway[0]?.inputs?.hash_key_live
        : "",
    recurring_passcode_test:
    formValues?.is_live === false
        ? formValues?.recurring_passcode_test
        ? formValues?.recurring_passcode_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.recurring_passcode_test
        ? savedgateway[0]?.inputs?.recurring_passcode_test
        : "",
    recurring_passcode_live:
    formValues?.is_live === true
        ? formValues?.recurring_passcode_live
        ? formValues?.recurring_passcode_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.recurring_passcode_live
        ? savedgateway[0]?.inputs?.recurring_passcode_live
        : "",
    reporting_passcode_test:
    formValues?.is_live === false
        ? formValues?.reporting_passcode_test
        ? formValues?.reporting_passcode_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.reporting_passcode_test
        ? savedgateway[0]?.inputs?.reporting_passcode_test
        : "",
    reporting_passcode_live:
    formValues?.is_live === true
        ? formValues?.reporting_passcode_live
        ? formValues?.reporting_passcode_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.reporting_passcode_live
        ? savedgateway[0]?.inputs?.reporting_passcode_live
        : "",
    batch_passcode_test:
    formValues?.is_live === false
        ? formValues?.batch_passcode_test
        ? formValues?.batch_passcode_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.batch_passcode_test
        ? savedgateway[0]?.inputs?.batch_passcode_test
        : "",
    batch_passcode_live:
    formValues?.is_live === true
        ? formValues?.batch_passcode_live
        ? formValues?.batch_passcode_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.batch_passcode_live
        ? savedgateway[0]?.inputs?.batch_passcode_live
        : "",
    subscription_passcode_test:
    formValues?.is_live === false
        ? formValues?.subscription_passcode_test
        ? formValues?.subscription_passcode_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.subscription_passcode_test
        ? savedgateway[0]?.inputs?.subscription_passcode_test
        : "",
    subscription_passcode_live:
    formValues?.is_live === true
        ? formValues?.subscription_passcode_live
        ? formValues?.subscription_passcode_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.subscription_passcode_live
        ? savedgateway[0]?.inputs?.subscription_passcode_live
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Tangoindia") {
newVALUE = {
    api_id_live:
    formValues?.is_live === true
        ? formValues?.api_id_live
        ? formValues?.api_id_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_id_live
        ? savedgateway[0]?.inputs?.api_id_live
        : "",
    api_id_test:
    formValues?.is_live === false
        ? formValues?.api_id_test
        ? formValues?.api_id_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_id_test
        ? savedgateway[0]?.inputs?.api_id_test
        : "",
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_live
        ? savedgateway[0]?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_test
        ? savedgateway[0]?.inputs?.api_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "CFGPayments") {
newVALUE = {
    secret_key_live:
    formValues?.is_live === true
        ? formValues?.secret_key_live
        ? formValues?.secret_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.secret_key_live
        ? savedgateway[0]?.inputs?.secret_key_live
        : "",
    secret_key_test:
    formValues?.is_live === false
        ? formValues?.secret_key_test
        ? formValues?.secret_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.secret_key_test
        ? savedgateway[0]?.inputs?.secret_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Capa") {
newVALUE = {
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_live
        ? savedgateway[0]?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_test
        ? savedgateway[0]?.inputs?.api_key_test
        : "",
    webhook_secret_live:
    formValues?.is_live === true
        ? formValues?.webhook_secret_live
        ? formValues?.webhook_secret_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.webhook_secret_live
        ? savedgateway[0]?.inputs?.webhook_secret_live
        : "",
    webhook_secret_test:
    formValues?.is_live === true
        ? formValues?.webhook_secret_test
        ? formValues?.webhook_secret_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.webhook_secret_test
        ? savedgateway[0]?.inputs?.webhook_secret_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Orionx") {
newVALUE = {
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_live
        ? savedgateway[0]?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_test
        ? savedgateway[0]?.inputs?.api_key_test
        : "",
    secret_key_live:
    formValues?.is_live === true
        ? formValues?.secret_key_live
        ? formValues?.secret_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.secret_key_live
        ? savedgateway[0]?.inputs?.secret_key_live
        : "",
    secret_key_test:
    formValues?.is_live === true
        ? formValues?.secret_key_test
        ? formValues?.secret_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.secret_key_test
        ? savedgateway[0]?.inputs?.secret_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Mauricio") {
newVALUE = {
    client_id_live:
    formValues?.is_live === true
        ? formValues?.client_id_live
        ? formValues?.client_id_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.client_id_live
        ? savedgateway[0]?.inputs?.client_id_live
        : "",
    client_id_test:
    formValues?.is_live === false
        ? formValues?.client_id_test
        ? formValues?.client_id_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.client_id_test
        ? savedgateway[0]?.inputs?.client_id_test
        : "",
    api_secret_live:
    formValues?.is_live === true
        ? formValues?.api_secret_live
        ? formValues?.api_secret_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_secret_live
        ? savedgateway[0]?.inputs?.api_secret_live
        : "",
    api_secret_test:
    formValues?.is_live === true
        ? formValues?.api_secret_test
        ? formValues?.api_secret_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_secret_test
        ? savedgateway[0]?.inputs?.api_secret_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Blox") {
newVALUE = {
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_live
        ? savedgateway[0]?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_test
        ? savedgateway[0]?.inputs?.api_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Terracall") {
newVALUE = {
    client_id_live:
    formValues?.is_live === true
        ? formValues?.client_id_live
        ? formValues?.client_id_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.client_id_live
        ? savedgateway[0]?.inputs?.client_id_live
        : "",
    client_id_test:
    formValues?.is_live === true
        ? formValues?.client_id_test
        ? formValues?.client_id_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.client_id_test
        ? savedgateway[0]?.inputs?.client_id_test
        : "",
    client_secret_live:
    formValues?.is_live === true
        ? formValues?.client_secret_live
        ? formValues?.client_secret_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.client_secret_live
        ? savedgateway[0]?.inputs?.client_secret_live
        : "",
    client_secret_test:
    formValues?.is_live === true
        ? formValues?.client_secret_test
        ? formValues?.client_secret_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.client_secret_test
        ? savedgateway[0]?.inputs?.client_secret_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "MyXspend") {
newVALUE = {
    email_live:
    formValues?.is_live === true
        ? formValues?.email_live
        ? formValues?.email_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.email_live
        ? savedgateway[0]?.inputs?.email_live
        : "",
    email_test:
    formValues?.is_live === true
        ? formValues?.email_test
        ? formValues?.email_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.email_test
        ? savedgateway[0]?.inputs?.email_test
        : "",
    password_live:
    formValues?.is_live === true
        ? formValues?.password_live
        ? formValues?.password_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.password_live
        ? savedgateway[0]?.inputs?.password_live
        : "",
    password_test:
    formValues?.is_live === true
        ? formValues?.password_test
        ? formValues?.password_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.password_test
        ? savedgateway[0]?.inputs?.password_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Bennupay") {
newVALUE = {
    secret_key_live:
    formValues?.is_live === true
        ? formValues?.secret_key_live
        ? formValues?.secret_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.secret_key_live
        ? savedgateway[0]?.inputs?.secret_key_live
        : "",
    secret_key_test:
    formValues?.is_live === true
        ? formValues?.secret_key_test
        ? formValues?.secret_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.secret_key_test
        ? savedgateway[0]?.inputs?.secret_key_test
        : "",
    brand_id_live:
    formValues?.is_live === true
        ? formValues?.brand_id_live
        ? formValues?.brand_id_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.brand_id_live
        ? savedgateway[0]?.inputs?.brand_id_live
        : "",
    brand_id_test:
    formValues?.is_live === true
        ? formValues?.brand_id_test
        ? formValues?.brand_id_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.brand_id_test
        ? savedgateway[0]?.inputs?.brand_id_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Xorapay") {
newVALUE = {
    secret_key_live:
    formValues?.is_live === true
        ? formValues?.secret_key_live
        ? formValues?.secret_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.secret_key_live
        ? savedgateway[0]?.inputs?.secret_key_live
        : "",
    secret_key_test:
    formValues?.is_live === true
        ? formValues?.secret_key_test
        ? formValues?.secret_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.secret_key_test
        ? savedgateway[0]?.inputs?.secret_key_test
        : "",
    encryption_key_live:
    formValues?.is_live === true
        ? formValues?.encryption_key_live
        ? formValues?.encryption_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.encryption_key_live
        ? savedgateway[0]?.inputs?.encryption_key_live
        : "",
    encryption_key_test:
    formValues?.is_live === true
        ? formValues?.encryption_key_test
        ? formValues?.encryption_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.encryption_key_test
        ? savedgateway[0]?.inputs?.encryption_key_test
        : "",
    webhook_hash_live:
    formValues?.is_live === true
        ? formValues?.webhook_hash_live
        ? formValues?.webhook_hash_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.webhook_hash_live
        ? savedgateway[0]?.inputs?.webhook_hash_live
        : "",
    webhook_hash_test:
    formValues?.is_live === true
        ? formValues?.webhook_hash_test
        ? formValues?.webhook_hash_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.webhook_hash_test
        ? savedgateway[0]?.inputs?.webhook_hash_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Murkon") {
newVALUE = {
    entity_login_live:
    formValues?.is_live === true
        ? formValues?.entity_login_live
        ? formValues?.entity_login_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.entity_login_live
        ? savedgateway[0]?.inputs?.entity_login_live
        : "",
    entity_login_test:
    formValues?.is_live === true
        ? formValues?.entity_login_test
        ? formValues?.entity_login_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.entity_login_test
        ? savedgateway[0]?.inputs?.entity_login_test
        : "",
    entity_pass_live:
    formValues?.is_live === true
        ? formValues?.entity_pass_live
        ? formValues?.entity_pass_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.entity_pass_live
        ? savedgateway[0]?.inputs?.entity_pass_live
        : "",
    entity_pass_test:
    formValues?.is_live === true
        ? formValues?.entity_pass_test
        ? formValues?.entity_pass_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.entity_pass_test
        ? savedgateway[0]?.inputs?.entity_pass_test
        : "",
    entity_code_live:
    formValues?.is_live === true
        ? formValues?.entity_code_live
        ? formValues?.entity_code_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.entity_code_live
        ? savedgateway[0]?.inputs?.entity_code_live
        : "",
    entity_code_test:
    formValues?.is_live === true
        ? formValues?.entity_code_test
        ? formValues?.entity_code_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.entity_code_test
        ? savedgateway[0]?.inputs?.entity_code_test
        : "",
    entity_type_live:
    formValues?.is_live === true
        ? formValues?.entity_type_live
        ? formValues?.entity_type_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.entity_type_live
        ? savedgateway[0]?.inputs?.entity_type_live
        : "",
    entity_type_test:
    formValues?.is_live === true
        ? formValues?.entity_type_test
        ? formValues?.entity_type_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.entity_type_test
        ? savedgateway[0]?.inputs?.entity_type_test
        : "",
    terminal_id_live:
    formValues?.is_live === true
        ? formValues?.terminal_id_live
        ? formValues?.terminal_id_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.terminal_id_live
        ? savedgateway[0]?.inputs?.terminal_id_live
        : "",
    terminal_id_test:
    formValues?.is_live === true
        ? formValues?.terminal_id_test
        ? formValues?.terminal_id_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.terminal_id_test
        ? savedgateway[0]?.inputs?.terminal_id_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Changelly Fiat") {
newVALUE = {
    public_api_key_live:
    formValues?.is_live === true
        ? formValues?.public_api_key_live
        ? formValues?.public_api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.public_api_key_live
        ? savedgateway[0]?.inputs?.public_api_key_live
        : "",
    public_api_key_test:
    formValues?.is_live === true
        ? formValues?.public_api_key_test
        ? formValues?.public_api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.public_api_key_test
        ? savedgateway[0]?.inputs?.public_api_key_test
        : "",
    private_key_live:
    formValues?.is_live === true
        ? formValues?.private_key_live
        ? formValues?.private_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.private_key_live
        ? savedgateway[0]?.inputs?.private_key_live
        : "",
    private_key_test:
    formValues?.is_live === true
        ? formValues?.private_key_test
        ? formValues?.private_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.private_key_test
        ? savedgateway[0]?.inputs?.private_key_test
        : "",
    provider_live:
    formValues?.is_live === true
        ? formValues?.provider_live
        ? formValues?.provider_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.provider_live
        ? savedgateway[0]?.inputs?.provider_live
        : "",
    provider_test:
    formValues?.is_live === true
        ? formValues?.provider_test
        ? formValues?.provider_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.provider_test
        ? savedgateway[0]?.inputs?.provider_test
        : "",
    wallet_address_live:
    formValues?.is_live === true
        ? formValues?.wallet_address_live
        ? formValues?.wallet_address_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.wallet_address_live
        ? savedgateway[0]?.inputs?.wallet_address_live
        : "",
    wallet_address_test:
    formValues?.is_live === true
        ? formValues?.wallet_address_test
        ? formValues?.wallet_address_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.wallet_address_test
        ? savedgateway[0]?.inputs?.wallet_address_test
        : "",
    to_currency_live:
    formValues?.is_live === true
        ? formValues?.to_currency_live
        ? formValues?.to_currency_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.to_currency_live
        ? savedgateway[0]?.inputs?.to_currency_live
        : "",
    to_currency_test:
    formValues?.is_live === true
        ? formValues?.to_currency_test
        ? formValues?.to_currency_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.to_currency_test
        ? savedgateway[0]?.inputs?.to_currency_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Changelly Crypto") {
newVALUE = {
    public_api_key_live:
    formValues?.is_live === true
        ? formValues?.public_api_key_live
        ? formValues?.public_api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.public_api_key_live
        ? savedgateway[0]?.inputs?.public_api_key_live
        : "",
    public_api_key_test:
    formValues?.is_live === true
        ? formValues?.public_api_key_test
        ? formValues?.public_api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.public_api_key_test
        ? savedgateway[0]?.inputs?.public_api_key_test
        : "",
    private_key_live:
    formValues?.is_live === true
        ? formValues?.private_key_live
        ? formValues?.private_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.private_key_live
        ? savedgateway[0]?.inputs?.private_key_live
        : "",
    private_key_test:
    formValues?.is_live === true
        ? formValues?.private_key_test
        ? formValues?.private_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.private_key_test
        ? savedgateway[0]?.inputs?.private_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Transvoucher") {
newVALUE = {
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_live
        ? savedgateway[0]?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_test
        ? savedgateway[0]?.inputs?.api_key_test
        : "",
    api_secret_live:
    formValues?.is_live === true
        ? formValues?.api_secret_live
        ? formValues?.api_secret_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_secret_live
        ? savedgateway[0]?.inputs?.api_secret_live
        : "",
    api_secret_test:
    formValues?.is_live === true
        ? formValues?.api_secret_test
        ? formValues?.api_secret_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_secret_test
        ? savedgateway[0]?.inputs?.api_secret_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "DNSPay") {
newVALUE = {
    endpoint_id_live:
    formValues?.is_live === true
        ? formValues?.endpoint_id_live
        ? formValues?.endpoint_id_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.endpoint_id_live
        ? savedgateway[0]?.inputs?.endpoint_id_live
        : "",
    endpoint_id_test:
    formValues?.is_live === true
        ? formValues?.endpoint_id_test
        ? formValues?.endpoint_id_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.endpoint_id_test
        ? savedgateway[0]?.inputs?.endpoint_id_test
        : "",
    merchant_key_live:
    formValues?.is_live === true
        ? formValues?.merchant_key_live
        ? formValues?.merchant_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchant_key_live
        ? savedgateway[0]?.inputs?.merchant_key_live
        : "",
    merchant_key_test:
    formValues?.is_live === true
        ? formValues?.merchant_key_test
        ? formValues?.merchant_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchant_key_test
        ? savedgateway[0]?.inputs?.merchant_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Gate2Way") {
newVALUE = {
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_live
        ? savedgateway[0]?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_test
        ? savedgateway[0]?.inputs?.api_key_test
        : "",
    api_secret_live:
    formValues?.is_live === true
        ? formValues?.api_secret_live
        ? formValues?.api_secret_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_secret_live
        ? savedgateway[0]?.inputs?.api_secret_live
        : "",
    api_secret_test:
    formValues?.is_live === true
        ? formValues?.api_secret_test
        ? formValues?.api_secret_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_secret_test
        ? savedgateway[0]?.inputs?.api_secret_test
        : "",
    payment_method_live:
    formValues?.is_live === true
        ? formValues?.payment_method_live
        ? formValues?.payment_method_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.payment_method_live
        ? savedgateway[0]?.inputs?.payment_method_live
        : "",
    payment_method_test:
    formValues?.is_live === true
        ? formValues?.payment_method_test
        ? formValues?.payment_method_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.payment_method_test
        ? savedgateway[0]?.inputs?.payment_method_test
        : "",
    payout_payment_method_live:
    formValues?.is_live === true
        ? formValues?.payout_payment_method_live
        ? formValues?.payout_payment_method_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.payout_payment_method_live
        ? savedgateway[0]?.inputs?.payout_payment_method_live
        : "",
    payout_payment_method_test:
    formValues?.is_live === true
        ? formValues?.payout_payment_method_test
        ? formValues?.payout_payment_method_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.payout_payment_method_test
        ? savedgateway[0]?.inputs?.payout_payment_method_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Payin") {
newVALUE = {
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_live
        ? savedgateway[0]?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_test
        ? savedgateway[0]?.inputs?.api_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Payouts Tech") {
newVALUE = {
    client_key_live:
    formValues?.is_live === true
        ? formValues?.client_key_live
        ? formValues?.client_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.client_key_live
        ? savedgateway[0]?.inputs?.client_key_live
        : "",
    client_key_test:
    formValues?.is_live === true
        ? formValues?.client_key_test
        ? formValues?.client_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.client_key_test
        ? savedgateway[0]?.inputs?.client_key_test
        : "",
    password_live:
    formValues?.is_live === true
        ? formValues?.password_live
        ? formValues?.password_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.password_live
        ? savedgateway[0]?.inputs?.password_live
        : "",
    password_test:
    formValues?.is_live === true
        ? formValues?.password_test
        ? formValues?.password_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.password_test
        ? savedgateway[0]?.inputs?.password_test
        : "",
    brand_live:
    formValues?.is_live === true
        ? formValues?.brand_live
        ? formValues?.brand_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.brand_live
        ? savedgateway[0]?.inputs?.brand_live
        : "",
    brand_test:
    formValues?.is_live === true
        ? formValues?.brand_test
        ? formValues?.brand_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.brand_test
        ? savedgateway[0]?.inputs?.brand_test
        : "",
    payout_client_key_live:
    formValues?.is_live === true
        ? formValues?.payout_client_key_live
        ? formValues?.payout_client_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.payout_client_key_live
        ? savedgateway[0]?.inputs?.payout_client_key_live
        : "",
    payout_client_key_test:
    formValues?.is_live === true
        ? formValues?.payout_client_key_test
        ? formValues?.payout_client_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.payout_client_key_test
        ? savedgateway[0]?.inputs?.payout_client_key_test
        : "",
    payout_password_live:
    formValues?.is_live === true
        ? formValues?.payout_password_live
        ? formValues?.payout_password_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.payout_password_live
        ? savedgateway[0]?.inputs?.payout_password_live
        : "",
    payout_password_test:
    formValues?.is_live === true
        ? formValues?.payout_password_test
        ? formValues?.payout_password_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.payout_password_test
        ? savedgateway[0]?.inputs?.payout_password_test
        : "",
    payout_brand_live:
    formValues?.is_live === true
        ? formValues?.payout_brand_live
        ? formValues?.payout_brand_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.payout_brand_live
        ? savedgateway[0]?.inputs?.payout_brand_live
        : "",
    payout_brand_test:
    formValues?.is_live === true
        ? formValues?.payout_brand_test
        ? formValues?.payout_brand_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.payout_brand_test
        ? savedgateway[0]?.inputs?.payout_brand_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "DirectPayment") {
newVALUE = {
    mid_live:
    formValues?.is_live === true
        ? formValues?.mid_live
        ? formValues?.mid_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.mid_live
        ? savedgateway[0]?.inputs?.mid_live
        : "",
    mid_test:
    formValues?.is_live === true
        ? formValues?.mid_test
        ? formValues?.mid_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.mid_test
        ? savedgateway[0]?.inputs?.mid_test
        : "",
    gateway_live:
    formValues?.is_live === true
        ? formValues?.gateway_live
        ? formValues?.gateway_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.gateway_live
        ? savedgateway[0]?.inputs?.gateway_live
        : "",
    gateway_test:
    formValues?.is_live === true
        ? formValues?.gateway_test
        ? formValues?.gateway_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.gateway_test
        ? savedgateway[0]?.inputs?.gateway_test
        : "",
    key_live:
    formValues?.is_live === true
        ? formValues?.key_live
        ? formValues?.key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.key_live
        ? savedgateway[0]?.inputs?.key_live
        : "",
    key_test:
    formValues?.is_live === true
        ? formValues?.key_test
        ? formValues?.key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.key_test
        ? savedgateway[0]?.inputs?.key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "JDPay") {
newVALUE = {
    merchant_id_live:
    formValues?.is_live === true
        ? formValues?.merchant_id_live
        ? formValues?.merchant_id_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchant_id_live
        ? savedgateway[0]?.inputs?.merchant_id_live
        : "",
    merchant_id_test:
    formValues?.is_live === true
        ? formValues?.merchant_id_test
        ? formValues?.merchant_id_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchant_id_test
        ? savedgateway[0]?.inputs?.merchant_id_test
        : "",
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_live
        ? savedgateway[0]?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_test
        ? savedgateway[0]?.inputs?.api_key_test
        : "",
    bank_code_live:
    formValues?.is_live === true
        ? formValues?.bank_code_live
        ? formValues?.bank_code_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.bank_code_live
        ? savedgateway[0]?.inputs?.bank_code_live
        : "",
    bank_code_test:
    formValues?.is_live === true
        ? formValues?.bank_code_test
        ? formValues?.bank_code_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.bank_code_test
        ? savedgateway[0]?.inputs?.bank_code_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Portinax") {
newVALUE = {
    merchant_key_live:
    formValues?.is_live === true
        ? formValues?.merchant_key_live
        ? formValues?.merchant_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchant_key_live
        ? savedgateway[0]?.inputs?.merchant_key_live
        : "",
    merchant_key_test:
    formValues?.is_live === true
        ? formValues?.merchant_key_test
        ? formValues?.merchant_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchant_key_test
        ? savedgateway[0]?.inputs?.merchant_key_test
        : "",
    password_live:
    formValues?.is_live === true
        ? formValues?.password_live
        ? formValues?.password_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.password_live
        ? savedgateway[0]?.inputs?.password_live
        : "",
    password_test:
    formValues?.is_live === true
        ? formValues?.password_test
        ? formValues?.password_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.password_test
        ? savedgateway[0]?.inputs?.password_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "TestGateway") {
newVALUE = {
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Re-set") {
newVALUE = {
    secretKey_live:
    formValues?.is_live === true
        ? formValues?.secretKey_live
        ? formValues?.secretKey_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.secretKey_live
        ? savedgateway[0]?.inputs?.secretKey_live
        : "",
    secretKey_test:
    formValues?.is_live === false
        ? formValues?.secretKey_test
        ? formValues?.secretKey_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.secretKey_test
        ? savedgateway[0]?.inputs?.secretKey_test
        : "",
    brand_id_live:
    formValues?.is_live === true
        ? formValues?.brand_id_live
        ? formValues?.brand_id_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.brand_id_live
        ? savedgateway[0]?.inputs?.brand_id_live
        : "",
    brand_id_test:
    formValues?.is_live === false
        ? formValues?.brand_id_test
        ? formValues?.brand_id_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.brand_id_test
        ? savedgateway[0]?.inputs?.brand_id_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Betapay") {
newVALUE = {
    api_token_live:
    formValues?.is_live === true
        ? formValues?.api_token_live
        ? formValues?.api_token_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_token_live
        ? savedgateway[0]?.inputs?.api_token_live
        : "",
    api_token_test:
    formValues?.is_live === false
        ? formValues?.api_token_test
        ? formValues?.api_token_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_token_test
        ? savedgateway[0]?.inputs?.api_token_test
        : "",
    merchant_id_live:
    formValues?.is_live === true
        ? formValues?.merchant_id_live
        ? formValues?.merchant_id_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchant_id_live
        ? savedgateway[0]?.inputs?.merchant_id_live
        : "",
    merchant_id_test:
    formValues?.is_live === true
        ? formValues?.merchant_id_test
        ? formValues?.merchant_id_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchant_id_test
        ? savedgateway[0]?.inputs?.merchant_id_test
        : "",
    terminal_id_live:
    formValues?.is_live === true
        ? formValues?.terminal_id_live
        ? formValues?.terminal_id_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.terminal_id_live
        ? savedgateway[0]?.inputs?.terminal_id_live
        : "",
    terminal_id_test:
    formValues?.is_live === true
        ? formValues?.terminal_id_test
        ? formValues?.terminal_id_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.terminal_id_test
        ? savedgateway[0]?.inputs?.terminal_id_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Aurea Via") {
newVALUE = {
    companyNum_live:
    formValues?.is_live === true
        ? formValues?.companyNum_live
        ? formValues?.companyNum_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.companyNum_live
        ? savedgateway[0]?.inputs?.companyNum_live
        : "",
    companyNum_test:
    formValues?.is_live === false
        ? formValues?.companyNum_test
        ? formValues?.companyNum_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.companyNum_test
        ? savedgateway[0]?.inputs?.companyNum_test
        : "",
    personalHashkey_live:
    formValues?.is_live === true
        ? formValues?.personalHashkey_live
        ? formValues?.personalHashkey_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.personalHashkey_live
        ? savedgateway[0]?.inputs?.personalHashkey_live
        : "",
    personalHashkey_test:
    formValues?.is_live === false
        ? formValues?.personalHashkey_test
        ? formValues?.personalHashkey_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.personalHashkey_test
        ? savedgateway[0]?.inputs?.personalHashkey_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Kasha") {
newVALUE = {
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_live
        ? savedgateway[0]?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_test
        ? savedgateway[0]?.inputs?.api_key_test
        : "",

    merchant_domain_live:
    formValues?.is_live === true
        ? formValues?.merchant_domain_live
        ? formValues?.merchant_domain_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchant_domain_live
        ? savedgateway[0]?.inputs?.merchant_domain_live
        : "",
    merchant_domain_test:
    formValues?.is_live === false
        ? formValues?.merchant_domain_test
        ? formValues?.merchant_domain_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchant_domain_test
        ? savedgateway[0]?.inputs?.merchant_domain_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Supefina") {
newVALUE = {
    merchant_id_live:
    formValues?.is_live === true
        ? formValues?.merchant_id_live
        ? formValues?.merchant_id_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchant_id_live
        ? savedgateway[0]?.inputs?.merchant_id_live
        : "",
    merchant_id_test:
    formValues?.is_live === false
        ? formValues?.merchant_id_test
        ? formValues?.merchant_id_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.merchant_id_test
        ? savedgateway[0]?.inputs?.merchant_id_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "3xpay") {
newVALUE = {
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_live
        ? savedgateway[0]?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_test
        ? savedgateway[0]?.inputs?.api_key_test
        : "",
    
    api_secret_live:
    formValues?.is_live === false
        ? formValues?.api_secret_live
        ? formValues?.api_secret_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_secret_live
        ? savedgateway[0]?.inputs?.api_secret_live
        : "",

    api_secret_test:
    formValues?.is_live === false
        ? formValues?.api_secret_test
        ? formValues?.api_secret_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_secret_test
        ? savedgateway[0]?.inputs?.api_secret_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Platy 2DS") {
newVALUE = {
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_live
        ? savedgateway[0]?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_test
        ? savedgateway[0]?.inputs?.api_key_test
        : "",
    password_live:
    formValues?.is_live === true
        ? formValues?.password_live
        ? formValues?.password_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.password_live
        ? savedgateway[0]?.inputs?.password_live
        : "",
    password_test:
    formValues?.is_live === false
        ? formValues?.password_test
        ? formValues?.password_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.password_test
        ? savedgateway[0]?.inputs?.password_test
        : "",

    platy_api_key_live:
    formValues?.is_live === false
        ? formValues?.platy_api_key_live
        ? formValues?.platy_api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.platy_api_key_live
        ? savedgateway[0]?.inputs?.platy_api_key_live
        : "",

    platy_api_key_test:
    formValues?.is_live === false
        ? formValues?.platy_api_key_test
        ? formValues?.platy_api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.platy_api_key_test
        ? savedgateway[0]?.inputs?.platy_api_key_test
        : "",

    platy_secret_key_live:
    formValues?.is_live === false
        ? formValues?.platy_secret_key_live
        ? formValues?.platy_secret_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.platy_secret_key_live
        ? savedgateway[0]?.inputs?.platy_secret_key_live
        : "",

    platy_secret_key_test:
    formValues?.is_live === false
        ? formValues?.platy_secret_key_test
        ? formValues?.platy_secret_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.platy_secret_key_test
        ? savedgateway[0]?.inputs?.platy_secret_key_test
        : "",

    username_live:
    formValues?.is_live === false
        ? formValues?.username_live
        ? formValues?.username_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.username_live
        ? savedgateway[0]?.inputs?.username_live
        : "",

    username_test:
    formValues?.is_live === false
        ? formValues?.username_test
        ? formValues?.username_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.username_test
        ? savedgateway[0]?.inputs?.username_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Platy 3DS") {
newVALUE = {
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_live
        ? savedgateway[0]?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.api_key_test
        ? savedgateway[0]?.inputs?.api_key_test
        : "",
    password_live:
    formValues?.is_live === true
        ? formValues?.password_live
        ? formValues?.password_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.password_live
        ? savedgateway[0]?.inputs?.password_live
        : "",
    password_test:
    formValues?.is_live === false
        ? formValues?.password_test
        ? formValues?.password_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.password_test
        ? savedgateway[0]?.inputs?.password_test
        : "",

    platy_api_key_live:
    formValues?.is_live === false
        ? formValues?.platy_api_key_live
        ? formValues?.platy_api_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.platy_api_key_live
        ? savedgateway[0]?.inputs?.platy_api_key_live
        : "",

    platy_api_key_test:
    formValues?.is_live === false
        ? formValues?.platy_api_key_test
        ? formValues?.platy_api_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.platy_api_key_test
        ? savedgateway[0]?.inputs?.platy_api_key_test
        : "",

    platy_secret_key_live:
    formValues?.is_live === false
        ? formValues?.platy_secret_key_live
        ? formValues?.platy_secret_key_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.platy_secret_key_live
        ? savedgateway[0]?.inputs?.platy_secret_key_live
        : "",

    platy_secret_key_test:
    formValues?.is_live === false
        ? formValues?.platy_secret_key_test
        ? formValues?.platy_secret_key_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.platy_secret_key_test
        ? savedgateway[0]?.inputs?.platy_secret_key_test
        : "",

    username_live:
    formValues?.is_live === false
        ? formValues?.username_live
        ? formValues?.username_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.username_live
        ? savedgateway[0]?.inputs?.username_live
        : "",

    username_test:
    formValues?.is_live === false
        ? formValues?.username_test
        ? formValues?.username_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.username_test
        ? savedgateway[0]?.inputs?.username_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}
if (type === "Bm2pay") {
newVALUE = {
    client_id_live:
    formValues?.is_live === true
        ? formValues?.client_id_live
        ? formValues?.client_id_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.client_id_live
        ? savedgateway[0]?.inputs?.client_id_live
        : "",
    client_id_test:
    formValues?.is_live === false
        ? formValues?.client_id_test
        ? formValues?.client_id_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.client_id_test
        ? savedgateway[0]?.inputs?.client_id_test
        : "",

    client_secret_live:
    formValues?.is_live === true
        ? formValues?.client_secret_live
        ? formValues?.client_secret_live?.trim()
        : ""
        : savedgateway[0]?.inputs?.client_secret_live
        ? savedgateway[0]?.inputs?.client_secret_live
        : "",
    client_secret_test:
    formValues?.is_live === false
        ? formValues?.client_secret_test
        ? formValues?.client_secret_test?.trim()
        : ""
        : savedgateway[0]?.inputs?.client_secret_test
        ? savedgateway[0]?.inputs?.client_secret_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
};
}

return newVALUE;

}